// const setSvgColor = (color) => {
// 	document
// 		.querySelectorAll('.slideshow__media svg .product-svg-fill')
// 		.forEach((path) => {
// 			if (path.classList.contains('product-svg-shadow'))
// 				path.style.fill = 'rgb(0 0 0 / 20%)';
// 			else path.style.fill = color;
// 		});
// };

let colorPicker;
document.addEventListener('DOMContentLoaded', function () {
	let setTries = 0;
	const setColorPicker = () => {
		setTries += 1;

		if (setTries > 10) return console.log('timed out');
		if (iro === undefined) return setTimeout(setColorPicker, 250);

		colorPicker = iro.ColorPicker('#iroPicker', {
			width: 200,
			margin: 12,
			color: 'rgb(255, 0, 0)',
			borderWidth: 0,
			layout: [
				{
					component: iro.ui.Slider,
					options: {
						sliderType: 'hue',
					},
				},
				{
					component: iro.ui.Slider,
					options: {
						sliderType: 'saturation',
					},
				},
				{
					component: iro.ui.Slider,
					options: {
						sliderType: 'value',
					},
				},
			],
		});

		colorPicker.on(['color:init', 'color:change'], function (color) {
			if (color && color.hexString) {
				const activeColorDiv = document.querySelector('#activeColor');
				if (activeColorDiv) {
					activeColorDiv.style.backgroundColor = color.hexString;
					const activeColorCode = activeColorDiv.querySelector('#colorCode');
					if (activeColorCode) {
						activeColorCode.innerHTML = color.hexString.toUpperCase();
						if (color.value <= 65) {
							activeColorDiv.style.color = 'white';
							activeColorDiv.style.stroke = 'white';
						} else {
							activeColorDiv.style.color = 'black';
							activeColorDiv.style.stroke = 'black';
						}
					}

					const names = ntc.name(color.hexString);
					const activeColorName = activeColorDiv.querySelector('#colorName');
					if (activeColorName) {
						activeColorName.textContent = names[1];
					}
				}
				// setSvgColor(color.hexString); // TODO - Redo this for V2
			}
		});
	};
	setColorPicker();
});

document.addEventListener('DOMContentLoaded', function () {
	// Select all color swatches
	const colorSwatches = document.querySelectorAll('.color-swatch');

	// Add click event listener to each swatch
	colorSwatches.forEach((swatch) => {
		swatch.addEventListener('click', function () {
			const color = swatch.getAttribute('data-color'); // Get the color from the data attribute
			console.log(`Swatch clicked: ${color}`); // Log the color (for debugging)

			// Update the active color display
			const activeColorDiv = document.querySelector('#activeColor');
			if (activeColorDiv) {
				activeColorDiv.style.backgroundColor = color;
				colorPicker.color.hexString = color; // Update the color picker to reflect the selected color
			}
		});
	});
});
